// Copyright (c) 2016 Deere & Company

import WarrantyExpiration from '@deere/cps-it.warranty-model-factory/lib/warranty-expiration';
import t from 'tcomb';

const WarrantyExpirationReport = t.list(WarrantyExpiration, 'Report');

export const getDefaultState = () => new WarrantyExpirationReport([]);

export default WarrantyExpirationReport;



// WEBPACK FOOTER //
// ./src/reports/warranty-expiration/state/report.js